function redirect(next, store) {
    if(store.getters.isApplicant) {
        return next({name: 'Applicant'})
    } else if(store.getters.isAdmin) {
        return next({name: 'Admin'})
    } else {
        return next({name: 'EmployeeApplicationsList'})
    }
}

export default async ({ next, store, nextMiddleware }) => {

    if(localStorage.getItem('accessToken')) {
        if (!store.getters.isAuthenticated) {
            await store.dispatch('fetchCurrentUser').then(() => {
                return redirect(next, store)
            }).catch(() => {
                store.dispatch('logout')

                return nextMiddleware();
            });
        } else return redirect(next, store)
    } else {
        nextMiddleware();
    }
}
